import Select from "react-select";
import { useEventList } from "./hooks";
import { useComponent, useElement, useLocale } from "../../../hooks";

export const EventsList = () => {
  const { t } = useLocale();
  const Button = useElement("Button");
  const Link = useElement("Link");
  const Input = useElement("Input");
  const Table = useComponent("Table");
  const TrashConfirmModal = useComponent("TrashConfirmModal");
  const {
    trackScrolling,
    trashAction,
    checkedList,
    checkedAll,
    setisMultipleDelete,
    setshowTrashConfirm,
    activeFilter,
    setactiveFilter,
    filterItems,
    filterTags,
    searchKey,
    search,
    resetSearch,
    tableContent,
    activeShownTotal,
    deleteChecked,
    deleteSelectEvent,
    trashCancel,
    showTrashConfirm,
    isMultipleDelete,
  } = useEventList();
  return (
    <div id="content-box" className="content" onScroll={trackScrolling}>
      <h1 className="title flex mb50">
        {t(trashAction ? "trashed" : "all")} Events
        {!trashAction && (
          <>
            <Link
              className="btn btn-primary btn-small ml20"
              href="/admin/event/add"
            >
              {t("add")}
            </Link>
            {(checkedList.length !== 0 || checkedAll) && (
              <Button
                onClick={() => {
                  setisMultipleDelete(true);
                  setshowTrashConfirm(true);
                }}
                className="btn btn-outline btn-small"
              >
                {t("delete")}
              </Button>
            )}
          </>
        )}
      </h1>
      <div className="filter-box">
        <div className="filters relative">
          <label className="filter-label-add">{t("status")}: </label>
          <Select
            value={activeFilter}
            defaultValue={activeFilter}
            onChange={(e) => {
              setactiveFilter(e);
              filterItems(e.value);
            }}
            options={filterTags}
          />
        </div>
        <div className="search-box">
          <Input
            name="searchKey"
            value={searchKey || ""}
            placeholder={t("placeholder.search")}
            onChange={search}
          />
          <i className="hi-close" onClick={resetSearch}></i>
        </div>
      </div>
      <Table data={tableContent} pageSize={activeShownTotal} />
      <TrashConfirmModal
        trashOkAction={() => {
          isMultipleDelete ? deleteChecked() : deleteSelectEvent();
        }}
        trashCancelAction={trashCancel}
        showTrashConfirm={showTrashConfirm}
        isMultipleDelete={isMultipleDelete}
      />
    </div>
  );
};
